import React, { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import { Button } from '@material-ui/core';
import Cookies from 'js-cookie';

import Users from './Users';
import Groups from './Groups';
import UserDetails from './UserDetails';
import DisableUser from './DisableUser';
import '../../scss/components/_user_management.scss';

import API_PATH from "../../constants/config.json";
import AddUser from './AddUser';
import GroupDetails from './GroupDetails';
import UsersInGroup from './UsersInGroup';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const GroupTabs = props => {

    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [usTab, setUsTab] = React.useState("fo");
    const [teTab, setTeTab] = React.useState("fo");

    const [needToReload, setNeedToReload] = useState(false);
    const [groupName, setGroupName] = useState(null);

    useEffect(() => {
        if(!needToReload) {
            setNeedToReload(true);
        }
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if(newValue === 1)  {
            props.setNeedToReload(true);
        }
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="management-main">
                <Container className="grouptabs-container" maxWidth="lg">
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Group details" {...a11yProps(0)} id="groupsTabb" data-testid="userListTab" className={usTab} />
                            <Tab label="Users in group" {...a11yProps(1)} id="usersingroup_tab" data-testid="teamListTab" className={teTab} />
                        </Tabs>
                        <div className="add-user-cnt">
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowGroupTabs(false)} style={{cursor: 'pointer'}} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} >
                        <div className="users-table-cnt" >
                            <GroupDetails 
                                setShowGroupTabs={props.setShowGroupTabs} 
                                setGroupName={setGroupName}
                                setNeedToReload={props.setNeedToReload}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={1} dir={theme.direction} >
                        <div className="users-table-cnt" >
                            <UsersInGroup 
                                groupName={groupName}
                                handleUserDetails={props.handleUserDetails}
                                setActiveUsername={props.setActiveUsername}
                                handleShowDisableUser={props.handleShowDisableUser}
                                needToReload={props.needToReload}
                                handleShowActions={props.handleShowActions}
                                handleScroll={props.handleScroll}
                                scrolled={props.scrolled}
                            />
                        </div>
                        </TabPanel>
                    </SwipeableViews>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default GroupTabs;